import React from 'react';

import { ClickAwayListener as MuiClickAwayListener } from '@mui/material';

const ClickAwayListener = React.forwardRef(({ children, ...props }, ref) => {
    return <MuiClickAwayListener {...props}>{children}</MuiClickAwayListener>;
});

export default ClickAwayListener;
